import PropTypes from 'prop-types'

import CardAdAttribute from './card-ad-attribute.js'

const BASE_CLASS_ATTR = 'mt-CardAd-attr'

const CardAdAttributes = ({attributes, id}) => {
  return (
    <ul className={BASE_CLASS_ATTR}>
      {attributes
        .filter(Boolean)
        .map(
          attribute =>
            Boolean(attribute.value) && <CardAdAttribute attribute={attribute} id={id} key={`${attribute.key}-${id}`} />
        )}
    </ul>
  )
}

CardAdAttributes.displayName = 'CardAdAttributes'

CardAdAttributes.propTypes = {
  attributes: PropTypes.array.isRequired,
  id: PropTypes.string
}

export default CardAdAttributes
